import { Component } from '@angular/core';

@Component({
  selector: 'app-always-there',
  imports: [],
  templateUrl: './always-there.html',
  styleUrl: './always-there.css',
})
export class AlwaysThere {

}
